import { getCurrentInstance } from 'vue'
import i18n from '@/i18n/i18n';

export function useNotifier() {
  const { proxy } = getCurrentInstance()

  const notify = ({ title, text, color = 'primary' }) => {
    if (!proxy || !proxy.$vs) {
     // console.error('Notifier: $vs no está disponible en el contexto.')
      return
    }
    proxy.$vs.notify({
      title:i18n.messages[i18n.locale][title],
      text:i18n.messages[i18n.locale][text],
      color
    })
  }

  return { notify }
}